import { render, staticRenderFns } from "./BlockDemo.vue?vue&type=template&id=3f61b639&"
import script from "./BlockDemo.vue?vue&type=script&lang=js&"
export * from "./BlockDemo.vue?vue&type=script&lang=js&"
import style0 from "./BlockDemo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f61b639')) {
      api.createRecord('3f61b639', component.options)
    } else {
      api.reload('3f61b639', component.options)
    }
    module.hot.accept("./BlockDemo.vue?vue&type=template&id=3f61b639&", function () {
      api.rerender('3f61b639', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/components/BlockDemo.vue"
export default component.exports